(function () {
  'use strict';

  if (window.EspinaBedenTablosuV1) return;
  window.EspinaBedenTablosuV1 = true;

  var aktifModal = null;
  var aktifDialog = null;
  var sonOdaklanan = null;

  var TABLOLAR = {
    'premium-oversize': {
      kategori: 'Oversize Tişört',
      kisaKategori: 'Oversize Tişört',
      baslik: 'Oversize Tişört Beden Rehberi',
      kalip: 'Oversize Kalıp',
      kalipMetni:
        'Daha salaş ve rahat bir görünüm için tasarlanmıştır.',
      sema: 'ust',

      bedenler: [
        'XS',
        'S',
        'M',
        'L',
        'XL',
        'XXL'
      ],

      satirlar: [
        ['Göğüs (A)', '54', '56', '58', '60', '62,5', '65,5'],
        ['Etek (B)', '51,5', '53,5', '55,5', '57,5', '60', '63'],
        ['Omuzdan Omuza (C)', '53', '55', '57', '59', '61', '63'],
        ['Omuzdan Boy (D)', '71', '72', '73', '74', '75,5', '77'],
        ['Kol Boyu (E)', '20', '21', '22', '23', '24', '25']
      ],

      ipucu:
        'Dengeli bir görünüm için kendi bedenini, daha salaş bir görünüm için bir beden büyük tercih edebilirsin.'
    },

    'cift-kollu-sweatshirt': {
      kategori: 'Çift Kollu Tişört',
      kisaKategori: 'Çift Kollu',
      baslik: 'Çift Kollu Tişört Beden Rehberi',
      kalip: 'Oversize Kalıp',
      kalipMetni:
        'Rahat ve hacimli duruş için oversize kalıpta hazırlanmıştır.',
      sema: 'ust',

      bedenler: [
        'S',
        'M',
        'L',
        'XL'
      ],

      satirlar: [
        ['Göğüs (A)', '55', '57', '59', '61'],
        ['Etek (B)', '53', '55', '57', '59,5'],
        ['Omuzdan Omuza (C)', '55', '57', '59', '61'],
        ['Omuzdan Boy (D)', '72', '73,5', '75', '77'],
        ['Kol Boyu (E)', '52', '53', '54', '55']
      ],

      ipucu:
        'İki beden arasında kalıyorsan daha rahat kullanım için büyük bedeni tercih edebilirsin.'
    },

    'sweatshirt': {
      kategori: 'Sweatshirt',
      kisaKategori: 'Sweatshirt',
      baslik: 'Sweatshirt Beden Rehberi',
      kalip: 'Normal Fit',
      kalipMetni:
        'Günlük kullanım için dengeli ve rahat bir kalıba sahiptir.',
      sema: 'ust',

      bedenler: [
        'S',
        'M',
        'L',
        'XL',
        'XXL'
      ],

      satirlar: [
        ['Göğüs (A)', '58', '60', '62', '64', '67'],
        ['Etek (B)', '42', '44', '46', '48', '51'],
        ['Omuzdan Omuza (C)', '49,5', '51', '52,5', '54', '55,5'],
        ['Omuzdan Boy (D)', '69,5', '71', '72,5', '74', '76'],
        ['Kol Boyu (E)', '60,5', '61,5', '62,5', '63,5', '64,5']
      ],

      ipucu:
        'Normal kalıp ürünlerde günlük kullanım için kendi bedenini tercih etmen önerilir.'
    },

    'fermuarli-sweatshirt': {
      kategori: 'Fermuarlı Sweatshirt',
      kisaKategori: 'Fermuarlı',
      baslik: 'Fermuarlı Sweatshirt Beden Rehberi',
      kalip: 'Normal Fit',
      kalipMetni:
        'Katmanlı kullanıma uygun, rahat normal kalıptadır.',
      sema: 'ust',

      bedenler: [
        'S',
        'M',
        'L',
        'XL',
        'XXL'
      ],

      satirlar: [
        ['Göğüs (A)', '58', '60', '62', '65', '68'],
        ['Etek (B)', '42', '44', '47', '50', '53'],
        ['Omuzdan Omuza (C)', '49', '51', '53', '55', '57'],
        ['Omuzdan Boy (D)', '72', '73', '74', '75', '76,5'],
        ['Kol Boyu (E)', '60', '61', '62', '63', '64']
      ],

      ipucu:
        'İçine tişört veya ince sweatshirt giyeceksen rahat kullanım için bir büyük beden tercih edebilirsin.'
    },

    'sweat-tunik': {
      kategori: 'Sweat Tunik',
      kisaKategori: 'Sweat Tunik',
      baslik: 'Sweat Tunik Beden Rehberi',
      kalip: 'Normal Fit',
      kalipMetni:
        'Uzun form ve rahat günlük kullanım için tasarlanmıştır.',
      sema: 'ust',

      bedenler: [
        'S',
        'M',
        'L',
        'XL',
        'XXL'
      ],

      satirlar: [
        ['Göğüs (A)', '55', '57', '59', '62', '65'],
        ['Etek (B)', '48', '50', '52', '55', '58'],
        ['Omuzdan Omuza (C)', '59', '60', '61', '62', '63'],
        ['Omuzdan Boy (D)', '75', '76', '77', '78', '79'],
        ['Kol Boyu (E)', '48', '49', '50', '51', '52']
      ],

      ipucu:
        'Tunik formda olduğu için beden seçerken özellikle ürün boyu ölçüsünü kontrol etmeni öneririz.'
    },

    'erkek-jogger': {
      kategori: 'Eşofman Altı',
      kisaKategori: 'Eşofman Altı',
      baslik: 'Eşofman Altı Beden Rehberi',
      kalip: 'Normal Fit',
      kalipMetni:
        'Bel lastiği esnek ancak ölçüler lastik esnetilmeden alınmıştır.',
      sema: 'alt',

      bedenler: [
        'S',
        'M',
        'L',
        'XL',
        'XXL'
      ],

      satirlar: [
        ['Bel Durgun (A)', '36', '38', '40', '43', '46'],
        ['Basen (B)', '53', '55', '57', '60', '63'],
        ['Baldır (C)', '31', '33', '35', '38', '41'],
        ['Yan Boy (D)', '102', '103', '104', '105,5', '107']
      ],

      ipucu:
        'Doğru seçim için bel ölçüsünün yanında basen ölçüsünü de kontrol etmeni öneririz.'
    },

    'sort': {
      kategori: 'Şort',
      kisaKategori: 'Şort',
      baslik: 'Şort Beden Rehberi',
      kalip: 'Normal Fit',
      kalipMetni:
        'Ölçüler ürün düz zemine serilerek alınmıştır.',
      sema: 'alt',

      bedenler: [
        'S',
        'M',
        'L',
        'XL',
        'XXL'
      ],

      satirlar: [
        ['Bel (A)', '35', '37', '39', '42', '45'],
        ['Basen (B)', '51', '53', '55', '57', '60'],
        ['Paça (C)', '29', '29,5', '30', '30,5', '31'],
        ['Boy (D)', '49', '50', '51', '52', '53']
      ],

      ipucu:
        'Rahat kullanım için bel ve basen ölçüsünü birlikte kontrol etmeni öneririz.'
    },

    'yelek': {
      kategori: 'Yelek',
      kisaKategori: 'Yelek',
      baslik: 'Yelek Beden Rehberi',
      kalip: 'Normal Fit',
      kalipMetni:
        'Kolsuz form nedeniyle göğüs ve etek ölçüsü seçimde daha belirleyicidir.',
      sema: 'yelek',

      bedenler: [
        'S',
        'M',
        'L',
        'XL',
        'XXL'
      ],

      satirlar: [
        ['Göğüs (A)', '48', '50', '52', '55', '58'],
        ['Etek (B)', '55', '57', '59', '62', '65'],
        ['Omuzdan Omuza (C)', '53', '54', '55', '56', '57'],
        ['Omuzdan Boy (D)', '59', '60', '61', '62', '63']
      ],

      ipucu:
        'İçine giyeceğin parçayı düşünerek göğüs ölçüsünde yeterli hareket payı bırakmanı öneririz.'
    },

    'kadin-crop-tshirt': {
      kategori: 'Crop Tişört',
      kisaKategori: 'Crop Tişört',
      baslik: 'Crop Tişört Beden Rehberi',
      kalip: 'Crop Form',
      kalipMetni:
        'Kısa boylu modern bir görünüm için tasarlanmıştır.',
      sema: 'ust',

      bedenler: [
        'S',
        'M',
        'L',
        'XL',
        'XXL'
      ],

      satirlar: [
        ['Göğüs (A)', '46', '48', '50', '53', '56'],
        ['Etek (B)', '45', '47', '49', '52', '55'],
        ['Omuzdan Omuza (C)', '41', '43', '45', '47', '49'],
        ['Omuzdan Boy (D)', '42', '43', '44', '45', '46'],
        ['Kol Boyu (E)', '19,5', '20', '20,5', '21', '21,5']
      ],

      ipucu:
        'Crop ürünlerde ürün boyu kısa olduğu için Omuzdan Boy ölçüsünü özellikle kontrol etmeni öneririz.'
    },

    'erkek-buyuk-beden': {
      kategori: 'Erkek Büyük Beden',
      kisaKategori: 'Erkek Büyük Beden',
      baslik: 'Erkek Büyük Beden Rehberi',
      kalip: 'Büyük Beden',
      kalipMetni:
        'Büyük beden kalıbına göre hazırlanmıştır.',
      sema: 'ust',

      bedenler: [
        '3XL - 48',
        '4XL - 50',
        '5XL - 52',
        '6XL - 54'
      ],

      satirlar: [
        ['Göğüs (A)', '70', '73', '76', '79'],
        ['Etek (B)', '68', '71', '74', '77'],
        ['Omuzdan Omuza (C)', '67', '70', '73', '76'],
        ['Omuzdan Boy (D)', '82', '83,5', '85', '86,5'],
        ['Kol Boyu (E)', '26', '27', '28', '29']
      ],

      ipucu:
        'Büyük beden ürünlerde göğüs ve etek ölçüsünü birlikte kontrol etmek daha doğru seçim sağlar.'
    },

    'kadin-buyuk-beden': {
      kategori: 'Kadın Büyük Beden',
      kisaKategori: 'Kadın Büyük Beden',
      baslik: 'Kadın Büyük Beden Rehberi',
      kalip: 'Büyük Beden',
      kalipMetni:
        'Büyük beden kalıbına göre hazırlanmıştır.',
      sema: 'ust',

      bedenler: [
        '3XL - 48',
        '4XL - 50',
        '5XL - 52',
        '6XL - 54'
      ],

      satirlar: [
        ['Göğüs (A)', '67', '70', '73', '76'],
        ['Etek (B)', '65', '68', '71', '74'],
        ['Omuzdan Omuza (C)', '64', '67', '70', '73'],
        ['Omuzdan Boy (D)', '80', '81,5', '83', '84,5'],
        ['Kol Boyu (E)', '24', '25', '26', '27']
      ],

      ipucu:
        'Rahat kullanım için göğüs, etek ve ürün boyu ölçülerini birlikte kontrol etmeni öneririz.'
    }
  };

  var TABLO_SIRASI = [
    'premium-oversize',
    'sweatshirt',
    'fermuarli-sweatshirt',
    'cift-kollu-sweatshirt',
    'sweat-tunik',
    'erkek-jogger',
    'sort',
    'yelek',
    'kadin-crop-tshirt',
    'erkek-buyuk-beden',
    'kadin-buyuk-beden'
  ];

  var OLCUM_ACIKLAMALARI = {
    ust: [
      [
        'A',
        'Göğüs',
        'Ürünü düz zemine ser. Koltuk altından koltuk altına yatay ölç.'
      ],
      [
        'B',
        'Etek',
        'Etek ucunda bir yan dikişten diğer yan dikişe yatay ölç.'
      ],
      [
        'C',
        'Omuzdan Omuza',
        'Bir omuz dikişinden diğer omuz dikişine yatay ölç.'
      ],
      [
        'D',
        'Omuzdan Boy',
        'Omuzun en üst noktasından ürünün etek ucuna kadar dikey ölç.'
      ],
      [
        'E',
        'Kol Boyu',
        'Omuz dikişinden kol ağzına kadar kol boyunca ölç.'
      ]
    ],

    alt: [
      [
        'A',
        'Bel',
        'Bel lastiğini esnetmeden ürünün düz genişliğini ölç.'
      ],
      [
        'B',
        'Basen',
        'Ürünün en geniş basen noktasından yatay ölç.'
      ],
      [
        'C',
        'Baldır / Paça',
        'Modelin ilgili baldır veya paça bölgesinden yatay ölç.'
      ],
      [
        'D',
        'Yan Boy',
        'Belin üst noktasından paça ucuna kadar yan dikiş boyunca ölç.'
      ]
    ],

    yelek: [
      [
        'A',
        'Göğüs',
        'Koltuk altından koltuk altına yatay ölç.'
      ],
      [
        'B',
        'Etek',
        'Etek ucunda bir yan dikişten diğerine ölç.'
      ],
      [
        'C',
        'Omuzdan Omuza',
        'İki omuz noktası arasındaki düz genişliği ölç.'
      ],
      [
        'D',
        'Omuzdan Boy',
        'Omuz tepe noktasından etek ucuna kadar dikey ölç.'
      ]
    ]
  };

  var odaklanabilirSecici = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function htmlKacis(deger) {
    return String(deger).replace(
      /[&<>"']/g,
      function (karakter) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        }[karakter];
      }
    );
  }

  function tabloGetir(handle) {
    return TABLOLAR[handle] || TABLOLAR['premium-oversize'];
  }

  function varsayilanBedenIndeksi(tablo) {
    var mIndeksi = tablo.bedenler.indexOf('M');

    if (mIndeksi !== -1) {
      return mIndeksi;
    }

    return Math.floor(tablo.bedenler.length / 2);
  }

  function olcuHarfi(etiket) {
    var eslesme = String(etiket).match(/\(([A-Z])\)/);

    if (eslesme && eslesme[1]) {
      return eslesme[1];
    }

    return String(etiket).charAt(0).toUpperCase();
  }

  function ustSema() {
    return `
      <svg
        class="ep-beden-sema"
        viewBox="0 0 420 420"
        role="img"
        aria-label="Üst giyim ölçüm şeması"
      >
        <path
          class="ep-beden-sema__urun"
          d="M150 78 C175 98 245 98 270 78 L335 120 L310 205 L286 196 L292 350 H128 L134 196 L110 205 L85 120 Z"
        ></path>

        <path
          class="ep-beden-sema__detay"
          d="M172 82 C180 118 240 118 248 82 M128 350 H292 M134 196 V350 M286 196 V350"
        ></path>

        <line
          class="ep-beden-sema__olcu"
          x1="134"
          y1="184"
          x2="286"
          y2="184"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="210"
          cy="184"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="210"
          y="185"
        >A</text>

        <line
          class="ep-beden-sema__olcu"
          x1="128"
          y1="365"
          x2="292"
          y2="365"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="210"
          cy="365"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="210"
          y="366"
        >B</text>

        <line
          class="ep-beden-sema__olcu"
          x1="95"
          y1="112"
          x2="325"
          y2="112"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="210"
          cy="112"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="210"
          y="113"
        >C</text>

        <line
          class="ep-beden-sema__olcu"
          x1="62"
          y1="78"
          x2="62"
          y2="350"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="62"
          cy="214"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="62"
          y="215"
        >D</text>

        <line
          class="ep-beden-sema__olcu"
          x1="330"
          y1="120"
          x2="308"
          y2="205"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="319"
          cy="163"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="319"
          y="164"
        >E</text>

      </svg>
    `;
  }

  function altSema() {
    return `
      <svg
        class="ep-beden-sema"
        viewBox="0 0 420 420"
        role="img"
        aria-label="Alt giyim ölçüm şeması"
      >
        <path
          class="ep-beden-sema__urun"
          d="M135 55 H285 L305 360 H235 L210 145 L185 360 H115 Z"
        ></path>

        <path
          class="ep-beden-sema__detay"
          d="M135 88 H285 M210 55 V145 M185 360 H115 M235 360 H305"
        ></path>

        <line
          class="ep-beden-sema__olcu"
          x1="135"
          y1="38"
          x2="285"
          y2="38"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="210"
          cy="38"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="210"
          y="39"
        >A</text>

        <line
          class="ep-beden-sema__olcu"
          x1="120"
          y1="145"
          x2="300"
          y2="145"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="210"
          cy="145"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="210"
          y="146"
        >B</text>

        <line
          class="ep-beden-sema__olcu"
          x1="215"
          y1="275"
          x2="295"
          y2="275"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="255"
          cy="275"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="255"
          y="276"
        >C</text>

        <line
          class="ep-beden-sema__olcu"
          x1="82"
          y1="55"
          x2="82"
          y2="360"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="82"
          cy="210"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="82"
          y="211"
        >D</text>

      </svg>
    `;
  }

  function yelekSema() {
    return `
      <svg
        class="ep-beden-sema"
        viewBox="0 0 420 420"
        role="img"
        aria-label="Yelek ölçüm şeması"
      >
        <path
          class="ep-beden-sema__urun"
          d="M155 65 C175 85 245 85 265 65 L315 128 C292 160 288 195 292 350 H128 C132 195 128 160 105 128 Z"
        ></path>

        <path
          class="ep-beden-sema__detay"
          d="M178 76 C184 110 236 110 242 76 M210 98 V350 M128 350 H292"
        ></path>

        <line
          class="ep-beden-sema__olcu"
          x1="128"
          y1="185"
          x2="292"
          y2="185"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="210"
          cy="185"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="210"
          y="186"
        >A</text>

        <line
          class="ep-beden-sema__olcu"
          x1="128"
          y1="365"
          x2="292"
          y2="365"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="210"
          cy="365"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="210"
          y="366"
        >B</text>

        <line
          class="ep-beden-sema__olcu"
          x1="115"
          y1="112"
          x2="305"
          y2="112"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="210"
          cy="112"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="210"
          y="113"
        >C</text>

        <line
          class="ep-beden-sema__olcu"
          x1="82"
          y1="65"
          x2="82"
          y2="350"
        ></line>

        <circle
          class="ep-beden-sema__nokta"
          cx="82"
          cy="210"
          r="14"
        ></circle>

        <text
          class="ep-beden-sema__harf"
          x="82"
          y="211"
        >D</text>

      </svg>
    `;
  }

  function semaOlustur(tip) {
    if (tip === 'alt') {
      return altSema();
    }

    if (tip === 'yelek') {
      return yelekSema();
    }

    return ustSema();
  }

  function kategorileriOlustur(
    modal,
    aktifHandle
  ) {
    var alan =
      modal.querySelector(
        '[data-ep-beden-kategoriler]'
      );

    if (!alan) return;

    alan.innerHTML =
      TABLO_SIRASI.map(
        function (handle) {
          var tablo = TABLOLAR[handle];

          var aktif =
            handle === aktifHandle
              ? ' is-active'
              : '';

          return `
            <button
              type="button"
              class="ep-beden-kategori${aktif}"
              data-ep-beden-kategori="${htmlKacis(handle)}"
            >
              <span class="ep-beden-kategori__isim">
                ${htmlKacis(tablo.kisaKategori)}
              </span>

              <span class="ep-beden-kategori__kalip">
                ${htmlKacis(tablo.kalip)}
              </span>
            </button>
          `;
        }
      ).join('');
  }

  function bedenButonlariniOlustur(
    modal,
    tablo
  ) {
    var alan =
      modal.querySelector(
        '[data-ep-beden-butonlari]'
      );

    if (!alan) return;

    var secili =
      Number(
        modal.dataset.epSeciliBeden
      );

    alan.innerHTML =
      tablo.bedenler.map(
        function (beden, index) {
          return `
            <button
              type="button"
              class="ep-beden-buton${
                index === secili
                  ? ' is-active'
                  : ''
              }"
              data-ep-beden-sec="${index}"
            >
              ${htmlKacis(beden)}
            </button>
          `;
        }
      ).join('');
  }

  function seciliOlculeriOlustur(
    modal,
    tablo
  ) {
    var alan =
      modal.querySelector(
        '[data-ep-beden-secili-olculer]'
      );

    var baslik =
      modal.querySelector(
        '[data-ep-beden-secili-baslik]'
      );

    if (!alan) return;

    var secili =
      Number(
        modal.dataset.epSeciliBeden
      );

    var beden =
      tablo.bedenler[secili];

    if (baslik) {
      baslik.textContent =
        beden + ' beden ölçüleri';
    }

    alan.innerHTML =
      tablo.satirlar.map(
        function (satir) {
          var deger =
            satir[secili + 1];

          return `
            <article class="ep-beden-olcu-karti">

              <span
                class="ep-beden-olcu-karti__harf"
              >
                ${htmlKacis(
                  olcuHarfi(satir[0])
                )}
              </span>

              <div>

                <small>
                  ${htmlKacis(satir[0])}
                </small>

                <strong>
                  ${htmlKacis(deger)}
                  <em>cm</em>
                </strong>

              </div>

            </article>
          `;
        }
      ).join('');
  }

  function tabloyuOlustur(
    modal,
    tablo
  ) {
    var alan =
      modal.querySelector(
        '[data-ep-beden-tablo]'
      );

    if (!alan) return;

    var secili =
      Number(
        modal.dataset.epSeciliBeden
      );

    var basliklar =
      tablo.bedenler.map(
        function (beden, index) {
          return `
            <th
              scope="col"
              class="${
                index === secili
                  ? 'is-selected'
                  : ''
              }"
            >
              ${htmlKacis(beden)}
            </th>
          `;
        }
      ).join('');

    var govde =
      tablo.satirlar.map(
        function (satir) {
          var hucreler =
            satir.slice(1).map(
              function (deger, index) {
                return `
                  <td
                    class="${
                      index === secili
                        ? 'is-selected'
                        : ''
                    }"
                  >
                    ${htmlKacis(deger)}
                  </td>
                `;
              }
            ).join('');

          return `
            <tr>

              <th scope="row">
                ${htmlKacis(satir[0])}
              </th>

              ${hucreler}

            </tr>
          `;
        }
      ).join('');

    alan.innerHTML = `
      <table
        class="ep-beden-karsilastirma"
      >

        <thead>
          <tr>
            <th scope="col">
              Ölçü / Beden
            </th>

            ${basliklar}
          </tr>
        </thead>

        <tbody>
          ${govde}
        </tbody>

      </table>
    `;
  }

  function tabloUygula(
    modal,
    handle,
    bedeniKoru
  ) {
    if (!modal) return;

    var tablo =
      tabloGetir(handle);

    modal.dataset.epAktifTablo =
      handle;

    if (!bedeniKoru) {
      modal.dataset.epSeciliBeden =
        String(
          varsayilanBedenIndeksi(
            tablo
          )
        );
    } else {
      var secili =
        Number(
          modal.dataset.epSeciliBeden
        );

      if (
        Number.isNaN(secili) ||
        secili < 0 ||
        secili >= tablo.bedenler.length
      ) {
        modal.dataset.epSeciliBeden =
          String(
            varsayilanBedenIndeksi(
              tablo
            )
          );
      }
    }

    var baslik =
      modal.querySelector(
        '[data-ep-beden-baslik]'
      );

    var altBaslik =
      modal.querySelector(
        '[data-ep-beden-alt-baslik]'
      );

    var kalip =
      modal.querySelector(
        '[data-ep-beden-kalip]'
      );

    var kalipBaslik =
      modal.querySelector(
        '[data-ep-beden-kalip-baslik]'
      );

    var kalipMetin =
      modal.querySelector(
        '[data-ep-beden-kalip-metin]'
      );

    var ipucu =
      modal.querySelector(
        '[data-ep-beden-ipucu]'
      );

    var sema =
      modal.querySelector(
        '[data-ep-beden-sema]'
      );

    if (baslik) {
      baslik.textContent =
        tablo.baslik;
    }

    if (altBaslik) {
      altBaslik.textContent =
        'Doğru bedeni seçmen için ürün ölçülerini ve bedenler arasındaki farkları karşılaştır.';
    }

    if (kalip) {
      kalip.textContent =
        tablo.kalip;
    }

    if (kalipBaslik) {
      kalipBaslik.textContent =
        tablo.kalip;
    }

    if (kalipMetin) {
      kalipMetin.textContent =
        tablo.kalipMetni;
    }

    if (ipucu) {
      ipucu.textContent =
        tablo.ipucu;
    }

    if (sema) {
      sema.innerHTML =
        semaOlustur(
          tablo.sema
        );
    }

    kategorileriOlustur(
      modal,
      handle
    );

    bedenButonlariniOlustur(
      modal,
      tablo
    );

    seciliOlculeriOlustur(
      modal,
      tablo
    );

    tabloyuOlustur(
      modal,
      tablo
    );

    yardimKapat(modal);
  }

  function bedenSec(
    modal,
    index
  ) {
    if (!modal) return;

    var tablo =
      tabloGetir(
        modal.dataset.epAktifTablo
      );

    index =
      Number(index);

    if (
      Number.isNaN(index) ||
      index < 0 ||
      index >= tablo.bedenler.length
    ) {
      return;
    }

    modal.dataset.epSeciliBeden =
      String(index);

    bedenButonlariniOlustur(
      modal,
      tablo
    );

    seciliOlculeriOlustur(
      modal,
      tablo
    );

    tabloyuOlustur(
      modal,
      tablo
    );
  }

  function yardimKapat(modal) {
    if (!modal) return;

    var alan =
      modal.querySelector(
        '[data-ep-beden-yardim]'
      );

    if (alan) {
      alan.hidden = true;
    }
  }

  function olcumYardimiGoster(
    modal
  ) {
    if (!modal) return;

    var tablo =
      tabloGetir(
        modal.dataset.epAktifTablo
      );

    var alan =
      modal.querySelector(
        '[data-ep-beden-yardim]'
      );

    var baslik =
      modal.querySelector(
        '[data-ep-beden-yardim-baslik]'
      );

    var icerik =
      modal.querySelector(
        '[data-ep-beden-yardim-icerik]'
      );

    if (!alan || !icerik) {
      return;
    }

    if (baslik) {
      baslik.textContent =
        'Ölçüm noktaları nasıl alınır?';
    }

    var maddeler =
      OLCUM_ACIKLAMALARI[
        tablo.sema
      ] ||
      OLCUM_ACIKLAMALARI.ust;

    icerik.innerHTML = `
      <div class="ep-beden-yardim-grid">

        ${
          maddeler.map(
            function (madde) {
              return `
                <article
                  class="ep-beden-yardim-karti"
                >

                  <span>
                    ${htmlKacis(madde[0])}
                  </span>

                  <strong>
                    ${htmlKacis(madde[1])}
                  </strong>

                  <p>
                    ${htmlKacis(madde[2])}
                  </p>

                </article>
              `;
            }
          ).join('')
        }

      </div>
    `;

    alan.hidden = false;

    alan.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }

  function kararYardimiGoster(
    modal
  ) {
    if (!modal) return;

    var alan =
      modal.querySelector(
        '[data-ep-beden-yardim]'
      );

    var baslik =
      modal.querySelector(
        '[data-ep-beden-yardim-baslik]'
      );

    var icerik =
      modal.querySelector(
        '[data-ep-beden-yardim-icerik]'
      );

    if (!alan || !icerik) {
      return;
    }

    if (baslik) {
      baslik.textContent =
        'Nasıl karar vermelisin?';
    }

    icerik.innerHTML = `
      <div class="ep-beden-karar">

        <p>
          <strong>1.</strong>
          Evde sevdiğin ve sana iyi oturan
          bir ürünü düz zemine ser.
        </p>

        <p>
          <strong>2.</strong>
          Aynı ölçüm noktalarından ürününü ölç;
          vücut ölçünü değil ürün ölçünü karşılaştır.
        </p>

        <p>
          <strong>3.</strong>
          Tablodaki en yakın ölçülere bak.
          İki beden arasında kalıyorsan ürünün
          kalıp bilgisini dikkate al.
        </p>

      </div>
    `;

    alan.hidden = false;

    alan.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }

  function sayfayiKilitle() {
    document.documentElement.classList.add(
      'ep-beden-kilit'
    );
  }

  function sayfaKilidiniAc() {
    document.documentElement.classList.remove(
      'ep-beden-kilit'
    );
  }

  function modallariBodyyeTasi(
    scope
  ) {
    var kok =
      scope || document;

    kok
      .querySelectorAll(
        '[data-ep-beden-modal]'
      )
      .forEach(
        function (modal) {
          if (
            modal.parentElement !==
            document.body
          ) {
            document.body.appendChild(
              modal
            );
          }
        }
      );
  }

  function modalAc(
    id,
    tetikleyici
  ) {
    if (!id) return;

    var modal =
      document.getElementById(id);

    if (!modal) return;

    var dialog =
      modal.querySelector(
        '.ep-beden-modal__dialog'
      );

    if (!dialog) return;

    sonOdaklanan =
      tetikleyici ||
      document.activeElement;

    var kapsayici =
      tetikleyici
        ? tetikleyici.closest(
            '[data-ep-beden-tablosu]'
          )
        : null;

    var ilkHandle =
      kapsayici &&
      kapsayici.dataset.epIlkTablo
        ? kapsayici.dataset.epIlkTablo
        : modal.dataset.epIlkTablo;

    tabloUygula(
      modal,
      ilkHandle ||
        'premium-oversize',
      false
    );

    modal.hidden = false;

    modal.setAttribute(
      'aria-hidden',
      'false'
    );

    requestAnimationFrame(
      function () {
        modal.classList.add(
          'is-open'
        );
      }
    );

    aktifModal = modal;
    aktifDialog = dialog;

    sayfayiKilitle();

    window.setTimeout(
      function () {
        dialog.focus();
      },
      40
    );
  }

  function modalKapat(
    modal
  ) {
    if (!modal) return;

    modal.classList.remove(
      'is-open'
    );

    modal.setAttribute(
      'aria-hidden',
      'true'
    );

    if (aktifModal === modal) {
      aktifModal = null;
      aktifDialog = null;
    }

    sayfaKilidiniAc();

    window.setTimeout(
      function () {
        modal.hidden = true;

        if (
          sonOdaklanan &&
          typeof sonOdaklanan.focus ===
            'function'
        ) {
          sonOdaklanan.focus();
        }

        sonOdaklanan = null;
      },
      220
    );
  }

  function odaklanabilirleriGetir(
    kapsayici
  ) {
    if (!kapsayici) {
      return [];
    }

    return Array.prototype
      .slice.call(
        kapsayici.querySelectorAll(
          odaklanabilirSecici
        )
      )
      .filter(
        function (eleman) {
          return (
            eleman.offsetWidth > 0 ||
            eleman.offsetHeight > 0 ||
            eleman ===
              document.activeElement
          );
        }
      );
  }

  function odakTuzagi(event) {
    if (
      !aktifDialog ||
      event.key !== 'Tab'
    ) {
      return;
    }

    var elemanlar =
      odaklanabilirleriGetir(
        aktifDialog
      );

    if (!elemanlar.length) {
      event.preventDefault();
      aktifDialog.focus();
      return;
    }

    var ilk =
      elemanlar[0];

    var son =
      elemanlar[
        elemanlar.length - 1
      ];

    if (
      event.shiftKey &&
      document.activeElement === ilk
    ) {
      event.preventDefault();
      son.focus();
    } else if (
      !event.shiftKey &&
      document.activeElement === son
    ) {
      event.preventDefault();
      ilk.focus();
    }
  }

  function hazirla(scope) {
    var kok =
      scope || document;

    kok
      .querySelectorAll(
        '[data-ep-beden-modal]'
      )
      .forEach(
        function (modal) {
          modal.hidden = true;

          modal.setAttribute(
            'aria-hidden',
            'true'
          );

          if (
            !modal.dataset.epIlkTablo
          ) {
            modal.dataset.epIlkTablo =
              'premium-oversize';
          }
        }
      );

    modallariBodyyeTasi(kok);
  }

  document.addEventListener(
    'click',
    function (event) {

      var ac =
        event.target.closest(
          '[data-ep-beden-ac]'
        );

      if (ac) {
        event.preventDefault();

        modalAc(
          ac.getAttribute(
            'aria-controls'
          ),
          ac
        );

        return;
      }

      var kapat =
        event.target.closest(
          '[data-ep-beden-kapat]'
        );

      if (kapat) {
        event.preventDefault();

        modalKapat(
          kapat.closest(
            '[data-ep-beden-modal]'
          )
        );

        return;
      }

      var kategori =
        event.target.closest(
          '[data-ep-beden-kategori]'
        );

      if (kategori) {
        event.preventDefault();

        tabloUygula(
          kategori.closest(
            '[data-ep-beden-modal]'
          ),
          kategori.getAttribute(
            'data-ep-beden-kategori'
          ),
          false
        );

        return;
      }

      var beden =
        event.target.closest(
          '[data-ep-beden-sec]'
        );

      if (beden) {
        event.preventDefault();

        bedenSec(
          beden.closest(
            '[data-ep-beden-modal]'
          ),
          beden.getAttribute(
            'data-ep-beden-sec'
          )
        );

        return;
      }

      var olcum =
        event.target.closest(
          '[data-ep-beden-olcum-yardimi]'
        );

      if (olcum) {
        event.preventDefault();

        olcumYardimiGoster(
          olcum.closest(
            '[data-ep-beden-modal]'
          )
        );

        return;
      }

      var karar =
        event.target.closest(
          '[data-ep-beden-karar-yardimi]'
        );

      if (karar) {
        event.preventDefault();

        kararYardimiGoster(
          karar.closest(
            '[data-ep-beden-modal]'
          )
        );

        return;
      }

      var yardimKapatButonu =
        event.target.closest(
          '[data-ep-beden-yardim-kapat]'
        );

      if (yardimKapatButonu) {
        event.preventDefault();

        yardimKapat(
          yardimKapatButonu.closest(
            '[data-ep-beden-modal]'
          )
        );
      }
    }
  );

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        aktifModal
      ) {
        modalKapat(
          aktifModal
        );

        return;
      }

      odakTuzagi(event);
    }
  );

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        hazirla(document);
      }
    );
  } else {
    hazirla(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      hazirla(event.target);
    }
  );

})();